import { JoggCartLineItem } from "@jog/types"
import { kebabCase } from "lodash-es"
import { useMemo } from "react"

export const useLineItemLocalized = (data: JoggCartLineItem) => {
    if ("categoryAsUrlAllLocales" in data) {
        const locale = process.env.NEXT_PUBLIC_LOCALE!
        const categoryUrl = data.categoryAsUrlAllLocales?.[locale] || data.categoryAsUrlAllLocales?.en
        const name = data.name?.[locale] || data.name?.en
        const slug = data.productSlugAllLocales?.[locale] || data.productSlugAllLocales?.en
        const link = `/${categoryUrl}/${kebabCase(name)}/${kebabCase(slug)}`
        const promotion = data.promotionDescription?.[locale] || ""
        return {
            link,
            name,
            promotion,
        }
    }
    return {
        link: `/${data.path}`.replace(/^\/\//, "/"),
        name: data.name,
        promotion: data.promotionDescription,
    }
}

export const useLineItemPrice = (data: JoggCartLineItem) =>
    useMemo(() => {
        const firstPrice = data.prices.firstPriceInTheCart.centAmount
        if (data.prices.promotionalPrice && firstPrice > data.prices.promotionalPrice.centAmount)
            return { finalPrice: data.prices.promotionalPrice.centAmount, firstPrice }
        if (data.prices.discountPrice && firstPrice > data.prices.discountPrice.centAmount)
            return { finalPrice: data.prices.discountPrice.centAmount, firstPrice }
        return { finalPrice: null, firstPrice }
    }, [data.prices])
